import script from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderLogo.vue?vue&type=style&index=0&id=521f3cdc&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521f3cdc"]])

export default __exports__